<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl ">
                    Shiftboard
                </div>
            </div>
            <div>
                <p>Here you can see some of the schedules that ORNA is actively hiring for. If you see a schedule that seems
                    like you would be interested in, click “I’m interested” and someone from ORNA will contact you to
                    discuss the position.</p>
            </div>
            <div class="table-holder table-responsive ">
                <table class="table">
                    <thead>
                    <tr>
                        <th style="min-width:10rem">Location</th>
                        <th style="min-width:4.75rem">Mon</th>
                        <th style="min-width:4.75rem">Tue</th>
                        <th style="min-width:4.75rem">Wed</th>
                        <th style="min-width:4.75rem">Thu</th>
                        <th style="min-width:4.75rem">Fri</th>
                        <th style="min-width:4.75rem">Sat</th>
                        <th style="min-width:4.75rem">Sun</th>
                        <th class="text-center">Shift Information</th>
                        <th class="text-right pr-5">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="shift in listOfShifts"
                        :key="shift.id"
                        :class="{'locked-row': !shift.isInterested}"
                    >
                        <td>{{ shift.client.city ?? '' }}, {{ shift.client.state ?? '' }}</td>
                        <td class="text-center">
                            <div
                                class="shift-block-adm-shifts"
                                v-for="(shifts, index) in shift.schedule.monday"
                                :key="index + 'monday'"
                            >
                                <div>{{ shifts }}</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <div
                                v-for="(shifts, index) in shift.schedule.tuesday"
                                :key="index + 'tuesday'"
                                class="shift-block-adm-shifts"
                            >
                                <div>{{ shifts }}</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <div
                                class="shift-block-adm-shifts"
                                v-for="(shifts, index) in shift.schedule.wednesday"
                                :key="index + 'wednesday'"
                            >
                                <div>{{ shifts }}</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <div
                                v-for="(shifts, index) in shift.schedule.thursday"
                                :key="index + 'thursday'"
                                class="shift-block-adm-shifts">
                                <div>{{ shifts }}</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <div
                                class="shift-block-adm-shifts"
                                v-for="(shifts, index) in shift.schedule.friday"
                                :key="index + 'friday'">
                                <div>{{ shifts }}</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <div
                                v-for="(shifts, index) in shift.schedule.saturday"
                                :key="index + 'saturday'"
                                class="shift-block-adm-shifts"
                            >
                                <div>{{ shifts }}</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <div
                                class="shift-block-adm-shifts"
                                v-for="(shifts, index) in shift.schedule.sunday"
                                :key="index + 'sunday'"
                            >
                                <div>{{ shifts }}</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <a href="javascript:void(0)"
                               @click="showCustomModal('info',`shift`+shift.id)"
                            >More Details</a>

                            <EmployeeShiftModal
                                :title="`Please review the following information before officially requesting this schedule`"
                                :modal-id="getCustomModalId('info',`shift`+shift.id)"
                                :shift="shift"
                                :isActionModal="false"
                            >
                            </EmployeeShiftModal>

                        </td>
                        <td class="text-right">
                            <button
                                v-if="shift.isInterested"
                                class="btn btn--secondary btn--small"
                                @click="showCustomModal('notInterested', shift.id)"
                            >I’m no longer interested <br/> in this position
                            </button>
                            <button
                                v-else
                                class="btn btn--outline-primary btn--small"
                                @click="showCustomModal('interested',`shift`+shift.id)"
                            >I am interested
                            </button>

                            <EmployeeShiftModal
                                :title="`Please review the following information before officially requesting this schedule`"
                                :modal-id="getCustomModalId('interested',`shift`+shift.id)"
                                :shift="shift"
                                :isActionModal="true"
                                @confirm="sendRequest"
                            >
                            </EmployeeShiftModal>

                            <ActionModal confirm-text="Yes" reject-text="No"
                                         :modalId="getCustomModalId('notInterested', shift.id)"
                                         @confirm="unsubscribeFromShift(shift.id)">
                                <template #body>
                                    <div class="text-center mb-4">
                                        <h4>
                                            Are you sure that you would <br> like to retract your application for the job?
                                        </h4>
                                    </div>
                                </template>
                            </ActionModal>

                            <EyesShowModal
                                :title="`Thank you `"
                                :modal-text="`Thank you - your profile has been submitted to the account managers for this location. If your experience meets the needs of this location you will be contacted for training`"
                                :modalId="getCustomModalId('thank', shift.id)"
                            ></EyesShowModal>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <Pagination
                :currentPage="pagination.current_page"
                :lastPage="pagination.last_page"
                @changePage="changePage"
                @changeItemsPerPage="changeItemsPerPage"
            />

        </div>
    </div>

</template>

<script>

import Pagination from "../../../../../../resources/js/components/Pagination.vue";
import PaginationHandler from "../../../../../../resources/js/mixins/PaginationHandler";
import EmployeeShiftModal from "../../../../../../resources/js/components/EmployeeShiftModal.vue";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import ShiftBoardService from "../../../../ShiftBoard/resources/js/services/ShiftBoardService";
import EyesShowModal from "../../../../../../resources/js/components/EyesShowModal.vue";
import {createDebouncedFunction} from "../../../../../../resources/js/plugins/debounce";

export default {
    name: 'EmployeeShiftBoards',
    components: {EyesShowModal, ActionModal, EmployeeShiftModal, Pagination},
    mixins: [PaginationHandler, ModalHandler],
    props: {
        userInfo: {
            type: Object
        },
    },
    data() {
        return {
            loading: true,
            listOfShifts: [],
            filters: {
                search: '',
                page: 1,
                perPage: 10,
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        async sendRequest(shift) {
            this.$showLoadingMessage()
            try {
                await ShiftBoardService.subscribeToShiftBoard(this.userInfo.id, shift.id)
                this.showCustomModal('thank', shift.id)
                await this.getListOfShiftBoards()
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The request could not be sent, please try again!')
            }
        },
        async unsubscribeFromShift(shiftId) {
            this.$showLoadingMessage()
            try {
                await ShiftBoardService.unsubscribeFromShiftBoard(this.userInfo.id, shiftId)
                this.$showSuccessMessage('You have successfully unsubscribed from the shift')
                await this.getListOfShiftBoards()
            } catch (e) {
                this.$showErrorMessage('Something went wrong!')
            }
        },
        checkForRelevance(shifts) {
            this.listOfShifts = shifts.map(shift => {
                let found = shift.applicants.find(user => user.id === this.userInfo.id)
                if (found) {
                    return {...shift, isInterested: true}
                } else {
                    return {...shift, isInterested: false}
                }
            })
        },
        getList(filters) {
            this.getListOfShiftBoards(filters)
        },
        async getListOfShiftBoards() {
            try {
                const {data: response} = await ShiftBoardService.getListOfShifts(this.filters)
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
                if (response.data.length) {
                    this.checkForRelevance(response.data)
                }
            } catch (e) {
                console.error(e)
            }
        },
    },
    mounted() {
        if (this.userInfo.hide_shift_board || this.userInfo.status === 'inactive' ) {
            this.listOfShifts = []
            this.loading = false
        } else {
            this.getListOfShiftBoards()
        }
    }
}

</script>

<style scoped>

</style>
